import { createConnectionConfig, getParsedNftAccountsByOwner } from "@nfteyez/sol-rayz";


const CLUSTER_API_URL = 'https://icy-small-spree.solana-mainnet.quiknode.pro/';

async function getNfts() {
    const connection = createConnectionConfig(CLUSTER_API_URL, 'confirmed');
    const nftArray = await getParsedNftAccountsByOwner({
        publicAddress: localStorage.getItem(PUBLIC_KEY),
        connection,
    });

    // todo: do the filtering
    return nftArray;
}


export default {
    getNfts,
}
